
<template>
  <div class="intellidata-device-iorecord">
    <ListPageLayout :loading="tableLoading">
    <template #filter>
        <!--左侧上方搜索框-->
            <div class="searchbox">
              <form action="#" method="get" class="form-inline form-float">
                <div class="form-group">
                  <el-select
                    class="space-parking"
                    placeholder="请选择停车场"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="{ parkingId, parkingName } in parks"
                      :key="parkingId"
                      :value="parkingId"
                      :label="parkingName"
                    ></el-option>
                  </el-select>
                </div>
                <!-- <div class="form-group">
                  <label for>车位号:</label>
                 <input  class="form-control"
                      id
                      type="text"
                      placeholder="请输入车位号"
                      size="12"/>
                </div> -->
                <div class="form-group">
                  <el-date-picker type="datetimerange"></el-date-picker>
                </div>
                <div class="form-group others">
                  <span class="search_btn">
                    <button
                      @click="searchList"
                      type="button"
                      class="btn btn-primary"
                      id="search_btn" :disabled="tableLoading">
              <i v-if="tableLoading" class="el-icon-loading"></i>
              {{ tableLoading ? "查询中..." : "查询" }}
            </button>
                  </span>
                </div>
              </form>
            </div>
            <!--左侧列表展示进出场记录-->
    </template>

      <el-table
              ref="table"
              border
              :data="tableListData.rows"
              height="100%"
              width="100%"
              :header-cell-style="tableHeaderStyle"
              :cell-style="styleObj"
            >
              <el-table-column
                show-overflow-tooltip
                label="订单号"
                prop="parkingName"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="提现时间"
                prop="deviceCode"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="提现金额"
                prop="plateNum"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                label="到账账户"
                prop="enterTime"
              ></el-table-column>
              <el-table-column show-overflow-tooltip label="提现方式">
              </el-table-column>

              <el-table-column
                show-overflow-tooltip
                label="提现状态"
                prop="exitTime"
              ></el-table-column>
              <el-table-column show-overflow-tooltip label="提现前金额">
              </el-table-column>

              <el-table-column show-overflow-tooltip label="提现后金额">
              </el-table-column>
            </el-table>

      <template #pagination>
        <Page v-on:pagination="receivePaginationData"></Page>
      </template>
    </ListPageLayout>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";

import { requestIntellidataDeviceIORecord, shareParks } from "@/api/url";

import Page from "../../commons/page";
import ListPageLayout from '@/page/commons/ListPageLayout.vue';

export default {
  data() {
    return {
      tableLoading: false,
      parks: [],
      photoDialogVisible: false,
      photoY: false,
      photoN: false,
      treeData: {
        parkingId: "",
      },
      observer: null,
      recordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        elementHeight: "0",
      },
      observer1: null,
      innerRecordOldValue: {
        // 记录下旧的宽高数据，避免重复触发回调函数
        innerHeight: "0",
      },
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      moduleName: "",
      allFbType: [],
      search: {
        pageNumber: 1,
        pageSize: 10,
        plateNumber: "",
        beginDate: "",
        chargeDate: "",
      },
      tableListData: {
        rows: [],
      },
      tableListDataAll: {},

      defaultProps: {
        children: "children",
        label: "label",
      },
      formLabelWidth: "100px",

      dialogFormVisiblePhoto: false,
      allImgUrl: [],
      imgUrl: "",
    };
  },
  methods: {
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;

      this.tableList(this.search.pageNumber);
    },

    tableList: function(curPage) {
      var _this = this;
      this.tableLoading = true;
      this.$get(requestIntellidataDeviceIORecord(), {
        limit: this.search.pageSize,
        page: curPage,
        plateNum: this.search.plateNumber,
      }).then((data) => {
        if (data.status != 200) return;
        //翻页

        var rows = data.data.rows;

        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        _this.getPage(pageObj);
        _this.tableListData.rows = data.data.rows.map((record) => {
          if (!record?.enterImages) record.enterImages = "";
          if (!record?.exitImages) record.exitImages = "";
          return record;
        });
        _this.$nextTick(() => {
          _this.$refs.table.doLayout();
        });
      }).finally(() => {
        this.tableLoading = false;
      });
    },
    searchList: function() {
      if (this.tableLoading) return;
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function() {
      this.search.pageNumber = "1";
      this.search.fbMsg = "";
      this.tableList(this.search.pageNumber);
    },

    getShareParks() {
      this.$postRequest(shareParks(), {}).then((res) => {
        this.parks = res?.data?.data?.rows ?? [];
      });
    },
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
  },
  components: {
    ListPageLayout,
    Page,
  },

  mounted: function() {
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getShareParks();
  },
};
</script>

<style scoped>
.boxbgcolor {
  width: 100%;
  display: flex;
}
.table tr td {
  text-align: center;
}

.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.table thread tr td {
  text-align: center;
}
.pagbox {
  position: absolute;
  bottom: 20px;
  right: 20px;
}
.searchbox {
  background: #f9f9fb;
  /* height:130px;
          line-height:45px; */
  border-bottom: 10px solid #eff2f7;
}
.form-inline {
  display: flex;
  display: -webkit-flex;
  flex-wrap: wrap;
  align-items: center;
  height: 90px;
}
.search_btn,
.download_btn,
.refresh_btn {
  display: inline-block;
}
.refresh_btn {
  display: -webkit-flex;
  display: flex;
  align-items: center;
}
.others {
  display: -webkit-flex;
  display: flex;
  justify-content: center;
}
.intellidata-device-iorecord img {
  display: inline-block;
  margin-right: 2px;
}
</style>
